import React from "react";

const CountShimmer = () => {
  return (
    <div
      className="cursor-pointer rounded-xl p-6 flex flex-col justify-between h-48 relative 
                 bg-gradient-to-r from-gray-200 to-gray-300 animate-pulse"
    >
      {/* Active badge placeholder */}
      <div className="absolute top-1 left-3 h-5 w-12 bg-gray-300 rounded"></div>

      {/* Count Badge placeholder */}
      <div className="absolute top-4 right-4 w-16 h-16 rounded-full bg-gray-300 shadow-lg"></div>

      {/* Icon + Title placeholder */}
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 bg-gray-300 rounded-lg"></div>
        <div className="h-5 w-24 bg-gray-300 rounded"></div>
      </div>

      {/* Description placeholder */}
      <div className="mt-2 space-y-2">
        <div className="h-3 w-full bg-gray-300 rounded"></div>
        <div className="h-3 w-2/3 bg-gray-300 rounded"></div>
      </div>

      {/* Button placeholder */}
      <div className="mt-auto text-right">
        <div className="mt-3 px-4 py-2 w-24 h-8 bg-gray-300 rounded-lg inline-block"></div>
      </div>
    </div>
  );
};

export default CountShimmer;
